var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { Component } from 'react';
import { fromJS as Immutable } from 'immutable';
import PropTypes from 'prop-types';
import qs from 'qs';

import { RowList } from "../../Layout/Lists";
import Doc from "../../Library/components/Doc";
import { t, I18NLink } from "../../I18N";
import { selectSingleDocument } from "../../Library/actions/libraryActions";
import { wrapDispatch } from "../../Multireducer";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Slider from "./slider";

class ItemList extends Component {
  render() {
    const { items, link } = this.props;
    const { sort } = qs.parse(link.substring(link.indexOf('?')), { ignoreQueryPrefix: true });
    const searchParams = sort ? { sort } : { sort: 'title' };

    const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
      {
        onClick: (_e, item) => selectSingleDocument(item)
      },
      wrapDispatch(dispatch, 'library')
    );

    const toRenderItems = items.map((item) => {
      const ConnectedItem = connect(null, mapDispatchToProps)(Doc);
      return /*#__PURE__*/(
        _jsx(ConnectedItem, {

          doc: Immutable(item),
          searchParams: searchParams,
          storeKey: "library" }, item._id
        ));

    });

    let list = /*#__PURE__*/_jsx(RowList, {}, void 0, toRenderItems);

    if (this.props.options.slider) {
      list = /*#__PURE__*/
      _jsx(RowList, {}, void 0, /*#__PURE__*/
      _jsx(Slider, { visibleCount: 3 }, void 0, toRenderItems)
      );

    }

    return /*#__PURE__*/(
      _jsx("div", {}, void 0,
      list, /*#__PURE__*/
      _jsx("div", { className: "row" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "text-center col-sm-12" }, void 0, /*#__PURE__*/
      _jsx(I18NLink, { to: `${link}` }, void 0, /*#__PURE__*/
      _jsx("button", { className: "btn btn-default" }, void 0, t('System', 'View in library'))
      )
      )
      )
      ));

  }
}

ItemList.defaultProps = {
  items: [],
  options: {}
};







export { ItemList };
export default ItemList;